import React, {useEffect, useState} from 'react';
import {useFetching} from "../../hooks/useFetching";
import {API_ABOUT_OUR_GOAL} from "../../utils/consts";
import parse from "html-react-parser";
import {useLocation} from "react-router-dom";
import {useWebPSupportCheck} from "react-use-webp-support-check";
import ApiAboutOurGoal from "../../services/About/OurGoal";
import {observer} from "mobx-react-lite";
import { Parallax, useParallaxController } from 'react-scroll-parallax';

import parallax2webp from "../../img/about/parallax2.webp";
import parallax2jpg from "../../img/about/parallax2.jpg";

const OurGoal = () => {
    const location = useLocation();
    const supportsWebP = useWebPSupportCheck();
    const parallaxController = useParallaxController();

    const [data, setData] = useState();
    // const [data, setData] = useState({name: 'Наша мета', content: '<p>Основна мета Champion™ - це поєднання високої якості виробництва, багаторічного досвіду та найсучасніших технологій, що відповідають міжнародним стандартам. Ми прагнемо розширити можливості наших клієнтів, створюючи якісне програмне та апаратне забезпечення для грального бізнесу.</p>'});

    const [FunctionApiAboutOurGoal] = useFetching(async () => {
        try {
            const response = await ApiAboutOurGoal.getApiAboutOurGoal(API_ABOUT_OUR_GOAL);
            setData(response.data);
        } catch {
            console.error('FunctionApiAboutOurGoal')
        }
    });

    useEffect(() => {
        FunctionApiAboutOurGoal();
    }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="block_target up_catalog">
            <div className="back">
                <Parallax translateY={['78px', '-78px']}>
                    <img
                        className="thumbnail"
                        onLoad={() => parallaxController.update()}
                        src={supportsWebP ? parallax2webp : parallax2jpg}
                        alt="img"
                        style={{transform: 'scale(1.3)'}}
                    />
                </Parallax>
            </div>
            {data ? <div className="title_block">
                {data.name && <h1>{data.name}</h1>}
                {data.content && parse(data.content)}
            </div> : null }
        </div>
    );
};

export default observer(OurGoal);